import styled from 'styled-components';
import NumberInputField from '../../../../../Form/NumberInputField';
import { fieldErrorStyles } from '../../../../../Form/inputStyles';
import { theme } from '../../../../../../styles/theme';

export const AutoRangeBucketsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const AutoRangeBucketRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 136px;
  column-gap: 8px;
`;

export const AutoRangeLabel = styled.div`
  padding-top: 4px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

export const AutoRangeNumberInputWrapper = styled.div`
  flex: 0 0 136px;
  width: 136px;
`;

export const AutoRangeNumberInput = styled(NumberInputField)`
  > input {
    width: 100%;
  }
`;

export const ErrorText = styled.div<{ $centered?: boolean }>`
  ${fieldErrorStyles};
  ${({ $centered }) =>
    $centered &&
    `
    text-align: center;
  `}
`;

export const BinError = styled(ErrorText)`
  max-width: 184px;
  margin-left: 24px;
`;

export const ManualRangeBracket = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr 13px 1fr 24px;
  column-gap: 8px;
  text-align: center;
`;

export const ManualRangeNumberInput = styled(NumberInputField)`
  > input {
    width: 78px;
  }
`;
